import { createAction, props } from '@ngrx/store';
import { NoteSubject } from 'mojo-irp-notes';

export const fastrNotesLoad = createAction(
  '[Fastr Notes] Load Notes',
  props<{
    subjectType: NoteSubject;
    subjectId: string;
    pageNumber: number;
  }>(),
);
